import {
  Button,
  Container,
  ExpandableSection,
  Grid,
  Header,
  SpaceBetween,
} from '@amzn/awsui-components-react-v3';
import { fill } from 'lodash';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import KeyValue from '../../../../components/KeyValue';
import { normalizeTranslationKey } from '../../../../utils';
import { ReceiveExceptionView } from '../types';

export type ExceptionDetailsMatchProps = {
  exceptionId: string;
};

export default function ExceptionDetails({ data }: { data: ReceiveExceptionView }): ReactElement {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Container
      header={
        <Header
          variant="h2"
          description=""
          actions={
            <>
              {data?.isEditable && (
                <Button
                  variant="normal"
                  onClick={() => history.push(`/receive/exception/${data.exceptionId}/edit`)}>
                  {t('Edit exception')}
                </Button>
              )}
            </>
          }>
          {t('Exception Details')}
        </Header>
      }
      footer={
        <ExpandableSection header={t('Serial Numbers')} variant="footer">
          {data.serials.join(', ')}
        </ExpandableSection>
      }>
      <SpaceBetween direction="vertical" size="l">
        <Grid gridDefinition={fill(Array(24), { colspan: { default: 3 } })}>
          <KeyValue label="Status">
            {t(`receive-exception.status-${normalizeTranslationKey(data.status)}`) as string}
          </KeyValue>
          <KeyValue label={t('Assigned To')}>{data.assignedToId}</KeyValue>
          <KeyValue label={t('Created By')}>{data.createdBy}</KeyValue>
          <KeyValue label={t('Created Date')}>{data.createdAt}</KeyValue>
          <KeyValue label={t('Exception Type')}>{data.exceptionType}</KeyValue>
          <KeyValue label={t('Site')}>{data.site}</KeyValue>
          <KeyValue label={t('Shipment ID')}>{data.shipmentReferenceId}</KeyValue>
          <KeyValue label={t('Order Type')}>{data.orderType}</KeyValue>
          <KeyValue label={t('Order Number')}>{data.orderNumber}</KeyValue>
          <KeyValue label={t('Order Line Number / Entire Order')}>
            {(data.orderLineNumber || t('Entire Order')) as string}
          </KeyValue>
          <KeyValue label={t('Tracking or Bill of Lading (BOL) number')}>
            {data.trackingNumber}
          </KeyValue>
          <KeyValue label={t('Holding Container')}>{data.holdingLocation}</KeyValue>
          <KeyValue label={t('Model')}>{data.model}</KeyValue>
          <KeyValue label={t('APN/IPN')}>{data.legacyModelId}</KeyValue>
          <KeyValue label={t('Quantity')}>{`${data.quantity}`}</KeyValue>
          <KeyValue label={t('Tags')}>{`${data.tags.join(', ')}`}</KeyValue>
        </Grid>
      </SpaceBetween>
    </Container>
  );
}
